import React from 'react';
import AggregateDataTable from '../components/AggregateDataTable';
import { usePolicies } from '../context/PoliciesContext';

const AggregateDataPage = () => {
  const { policies } = usePolicies();

  if (policies.length === 0) {
    return (
      <div className="space-y-6">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Aggregate Data</h1>
          <p className="text-gray-600">Revenue analysis and payment aggregation by time periods</p>
        </div>
        
        <div className="card text-center py-12">
          <div className="text-gray-500 mb-4">
            <svg className="mx-auto h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No Data Available</h3>
          <p className="text-gray-600 mb-4">
            Upload documents in the Dashboard to start analyzing revenue streams
          </p>
          <a 
            href="/dashboard" 
            className="inline-flex items-center px-4 py-2 bg-enpact-red text-white rounded-lg hover:bg-enpact-red-dark transition-colors duration-200"
          >
            Go to Dashboard
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Aggregate Data</h1>
        <p className="text-gray-600">Revenue analysis and payment aggregation by time periods</p>
      </div>
      
      <AggregateDataTable policies={policies} />
    </div>
  );
};

export default AggregateDataPage;
